module.exports = __webpack_public_path__ + "img/Festival-text.02fc6567.jpg";